<div *ngIf="isModalOpen" class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="stopPropagate($event)">
    <span class="close-icon" (click)="onClose()">&times;</span>
    <div>
      <h3>¿Estás seguro que deseas retirar tu inscripción?</h3>
      <div class="modal-buttons">
        <button class="btn-back" (click)="onClose()">Volver atrás</button>
        <button class="btn-cancel-inscription" (click)="onConfirm()">Cancelar inscripción</button>
      </div>
    </div>
  </div>
</div>
